// Generated by purs version 0.15.16
import * as $foreign from "./foreign.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
var showRegex = {
    show: $foreign.showRegexImpl
};
var search = /* #__PURE__ */ (function () {
    return $foreign["_search"](Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
})();
var replace$prime = /* #__PURE__ */ (function () {
    return $foreign["_replaceBy"](Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
})();
var renderFlags = function (v) {
    return (function () {
        if (v.global) {
            return "g";
        };
        return "";
    })() + ((function () {
        if (v.ignoreCase) {
            return "i";
        };
        return "";
    })() + ((function () {
        if (v.multiline) {
            return "m";
        };
        return "";
    })() + ((function () {
        if (v.dotAll) {
            return "s";
        };
        return "";
    })() + ((function () {
        if (v.sticky) {
            return "y";
        };
        return "";
    })() + (function () {
        if (v.unicode) {
            return "u";
        };
        return "";
    })()))));
};
var regex = function (s) {
    return function (f) {
        return $foreign.regexImpl(Data_Either.Left.create)(Data_Either.Right.create)(s)(renderFlags(f));
    };
};
var parseFlags = function (s) {
    return {
        global: Data_String_CodeUnits.contains("g")(s),
        ignoreCase: Data_String_CodeUnits.contains("i")(s),
        multiline: Data_String_CodeUnits.contains("m")(s),
        dotAll: Data_String_CodeUnits.contains("s")(s),
        sticky: Data_String_CodeUnits.contains("y")(s),
        unicode: Data_String_CodeUnits.contains("u")(s)
    };
};
var match = /* #__PURE__ */ (function () {
    return $foreign["_match"](Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
})();
var flags = function ($10) {
    return Data_String_Regex_Flags.RegexFlags($foreign.flagsImpl($10));
};
export {
    source,
    test,
    replace,
    split
} from "./foreign.js";
export {
    regex,
    flags,
    renderFlags,
    parseFlags,
    match,
    replace$prime,
    search,
    showRegex
};
//# sourceMappingURL=index.js.map
